import URLSearchParams from 'url-search-params'
export const getExternalParams = () => {
  const params = new URLSearchParams(window.location.search)

  return {
    gileadeToken: params.get('gileadeToken'),
    mapaLatitude: +params.get('mapaLatitude'),
    mapaLongitude: +params.get('mapaLongitude'),
    mapaZoom: +params.get('mapaZoom')
  }
}



// WEBPACK FOOTER //
// ./src/Services/externalParams.js